import React from "react";
import { Textarea } from "@heroui/react";

interface AdditionalNotesProps {
    t: any;
    notes: string;
    setNotes: (value: string) => void;
}

const AdditionalNotes: React.FC<AdditionalNotesProps> = ({
    t,
    notes,
    setNotes,
}) => {
    return (
        <div className="space-y-2">
            <h3 className="text-xs font-semibold text-gray-800 border-b pb-1">
                {t("additional_information")}
            </h3>
            <div className="space-y-1">
                <label className="text-xs font-medium text-gray-600 block">
                    {t("notes")}
                </label>
                <Textarea
                    placeholder={t("enter_notes_placeholder")}
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    maxLength={1000}
                    size="sm"
                    minRows={4}
                    classNames={{
                        input: "text-sm",
                    }}
                />
                <div className="text-xs text-gray-500 text-right">
                    {notes.length}/{t('characters')}
                </div>
            </div>
        </div>
    );
};

export default AdditionalNotes;